import { createFileRoute, redirect } from '@tanstack/react-router'
import { HrHome } from '@/features/hr-home/hr-home'
import { hasGrant } from '@/lib/me'

/**
 * Route shell for the HR landing page (design 1a), at `/hr`.
 *
 * `employee.view` and not a dashboard key of its own: the catalogue has none,
 * and the page is a set of counts over records the HR destinations already
 * gate. The API asks the same question — `HrHomeController` authorises
 * `viewAny` on Employee — so a stale grant still 403s server-side.
 *
 * Per the route-shell rule in `apps/company/AGENTS.md`, this file is a route
 * definition, a guard and a render.
 */
export const Route = createFileRoute('/_authenticated/hr/')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'employee.view')) {
      throw redirect({ to: '/' })
    }
  },
  component: HrHome,
})
